// @flow

export function createUniqueId () {
  return `_${Math.random()
    .toString(36)
    .substr(2, 9)}`
}



// WEBPACK FOOTER //
// ./src/lib/id.js